import { render, staticRenderFns } from "./numeric-score-entry.vue?vue&type=template&id=71b775e4&scoped=true"
import script from "./numeric-score-entry.vue?vue&type=script&lang=js"
export * from "./numeric-score-entry.vue?vue&type=script&lang=js"
import style0 from "./numeric-score-entry.vue?vue&type=style&index=0&id=71b775e4&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b775e4",
  null
  
)

export default component.exports